// Keep this object in sync with the analogous backend one in lib/terminal/sample_locations.rb
// These fixtures are also used in File.test.js unit tests
export const locales = {
  IE: {
    location: {
      name: 'HQ',
      line1: 'Grand Canal Street Lower',
      city: 'Dublin',
      country: 'IE',
      postal: 'D02 H210',
    },
    currency: 'eur',
  },
  NL: {
    location: {
      name: 'HQ',
      line1: 'Singel 542',
      city: 'Amsterdam',
      country: 'NL',
      postal: '1017 AZ',
    },
    currency: 'eur',
  },
  DE: {
    location: {
      name: 'HQ',
      line1: 'Stresemannstraße 123',
      city: 'Berlin',
      country: 'DE',
      postal: '10963',
    },
    currency: 'eur',
  },
  FR: {
    location: {
      name: 'HQ',
      line1: '10 Boulevard Haussmann',
      city: 'Paris',
      country: 'FR',
      postal: '75009',
    },
    currency: 'eur',
  },
  NZ: {
    location: {
      name: 'HQ',
      line1: '203 Victoria Street',
      city: 'Auckland Central',
      state: 'Auckland',
      country: 'NZ',
      postal: '1010',
    },
    currency: 'eur',
  },
  AU: {
    location: {
      name: 'HQ',
      line1: '1234 Victoria Street',
      city: 'Melbourne',
      state: 'Victoria',
      country: 'AU',
      postal: '3000',
    },
    currency: 'aud',
  },
  CA: {
    location: {
      name: 'HQ',
      line1: '3040 Bur Oak Ave',
      city: 'Markham',
      state: 'ON',
      country: 'CA',
      postal: 'L6B 0R1',
    },
    currency: 'cad',
  },
  SG: {
    location: {
      name: 'HQ',
      line1: '19 Keppel Road',
      city: 'Singapore',
      state: '',
      country: 'SG',
      postal: '089058',
    },
    currency: 'sgd',
  },
  US: {
    location: {
      name: 'HQ',
      line1: '1272 Valencia Street',
      city: 'San Francisco',
      state: 'CA',
      country: 'US',
      postal: '94110',
    },
    currency: 'usd',
  },
  GB: {
    location: {
      name: 'HQ',
      line1: '448A Crownhill Rd',
      city: 'Plymouth',
      country: 'GB',
      postal: 'PL5 2QT',
    },
    currency: 'gbp',
  },
};
